import { render, staticRenderFns } from "./SvDoubleInputList.vue?vue&type=template&id=a8cf1efe&scoped=true&lang=pug&"
import script from "./SvDoubleInputList.vue?vue&type=script&lang=js&"
export * from "./SvDoubleInputList.vue?vue&type=script&lang=js&"
import style0 from "./SvDoubleInputList.vue?vue&type=style&index=0&id=a8cf1efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cf1efe",
  null
  
)

export default component.exports